export default "__VITE_ASSET__BW2QxnfQ__"